import { RedoShopifyDeliveryMethodType } from "@redotech/redo-model/fulfillments/fulfillment-delivery-method-type";
import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { FulfillmentGroupStatus } from "@redotech/redo-model/fulfillments/fulfillment-group-status";

export function groupDataPickupInRedoButNotInShopify(
  group: FulfillmentGroupData,
) {
  return (
    group.status === FulfillmentGroupStatus.ReadyForPickup &&
    group.fulfillmentOrderIds.some((externalId) => {
      const deliveryMethod =
        group.fulfillmentOrderToDeliveryMethod[externalId]?.kind;
      return (
        deliveryMethod === RedoShopifyDeliveryMethodType.Shipping ||
        deliveryMethod === RedoShopifyDeliveryMethodType.Local ||
        deliveryMethod === RedoShopifyDeliveryMethodType.Freight
      );
    })
  );
}
